/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import debounce from "lodash/debounce";
import MultipleDropOff from "./MultipleDropOff";
import PassengerCard from "../cards/PassengerCard";
import {
  addSingleDestinationFormToState,
  addMultipleDestinationFormToState,
  addAirportFormToState,
  addByTheHourFormToState,
  addSpecifiedDestinationFormToState,
} from "../../../actions/admin/booking";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  getTotalPaxCount,
  getTotalLuggageCount,
} from "../../../utils/Calculator";
import { useTranslation } from "react-i18next";
import {
  registerLocale,
} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "moment/locale/ja";
import ja from "date-fns/locale/ja";
import CustomGoogleAutoComplete from "../../../components/layout-new-theme/google-input/CustomGoogleAutoComplete";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import {
  ButtonLoadingSwap,
  FieldError,
  searchButtonMotionProps,
} from "./formMotion";
import AnimatedDatePicker from "./AnimatedDatePicker";
import { pushEventGTM } from "../../../utils/gtm";
import {
  PaxIcon,
  LuggageIcon,
  ArrowRightIcon,
  LocationPinIcon,
  ClockIcon,
  CalendarIcon,
} from "../../icons";
import { MotionModal, ModalCloseButton } from "../../motion";
import { BROWSER_AUTOFILL_OFF } from "../../../utils/autofill";

// Identity for adjacent-duplicate checks. Dropoffs carry a random `value`, so
// duplicates must be compared by the real Google `place_id`.
const getPlaceId = (loc) => loc?.place_id || null;

// Returns the index (within `dropoffs`) of the first dropoff that repeats the
// location immediately before it — pickup for the first dropoff, otherwise the
// previous dropoff. Returns -1 when there is no adjacent duplicate.
const findDuplicateAdjacentDropoffIndex = (pickup, dropoffs = []) => {
  for (let i = 0; i < dropoffs.length; i++) {
    const currentId = getPlaceId(dropoffs[i]);
    const previousId = i === 0 ? getPlaceId(pickup) : getPlaceId(dropoffs[i - 1]);
    if (currentId && previousId && currentId === previousId) return i;
  }
  return -1;
};

const SpecifiedDestinationForm = ({
  specifiedDestinationForm,
  checkSpecifiedDestinationFormAvailableVehicle,
  availabilityValueReset,
  formValidationData,
  isLoading = null,
}) => {
  const { t, i18n } = useTranslation();
  const shouldReduceMotion = useReducedMotion();
  const wrapperRef = useRef(null);
  const dispatch = useDispatch();
  let history = useHistory();
  const search = useLocation();
  const settings = useSelector((state) => state.setting);
  const { lang } = settings;
  const [passengerVisible, setPassangeVisible] = useState(false);
  const [lugageVisible, setLugageVisible] = useState(false);
  const [pickuplocation, setpickuplocation] = useState("");
  const [dropofflocations, setdropofflocations] = useState([{}]);
  const [totalPax, setTotalPax] = useState(0);
  const [totalLugage, setTotalLugage] = useState(0);
  const [formatedTravelDate, setFormatedTravelDate] = useState("");
  const [travelDatePicker, setTravelDatePicker] = useState(new Date());
  const [specifiedDestinationFormData, setspecifiedDestinationFormData] = useState({
    pickuplocation: "",
    dropofflocations: [],
    traveldate: "",
    pickuptime: "",
    dropofftime: "",
    dropOffDateTime: "",
    pax: null,
    lugage: {
      checkinSize: 0,
      cabinSize: 0,
    },
    isAirportTransfer: false,
    isFromAirport: false,
    isToAirport: false,
    isStationTransfer: false,
    isFromStation: false,
    isToStation: false
  });
  const [changeLuggage, setChangeLuggage] = useState(specifiedDestinationForm != null ? true : false);
  const [formDataValidation, setformDataValidation] = useState(formValidationData);
  const [showDuplicateLocationModal, setShowDuplicateLocationModal] = useState(false);

  if (lang === "EN" || lang === "en") {
    moment.locale("en");
  } else {
    moment.locale("ja");
  }

  registerLocale("ja", ja);

  const dateFormat = {
    "EN": "MMM D, yyyy (ddd)",
    "JP": "YYYY年M月D日（ddd）",
    "en": "MMM D, yyyy (ddd)",
    "jp": "YYYY年M月D日（ddd）"
  }

  useEffect(() => {
    setformDataValidation(formValidationData);
  }, [formValidationData]);

  /**
   * * When the page is loading, check if the form data exists. If it exists, then this data will be filled to the input controllers.
   */
  useEffect(() => {
    if (
      specifiedDestinationForm === null ||
      specifiedDestinationForm === undefined
    )
      return;

    setpickuplocation(specifiedDestinationForm.pickuplocation);
    setdropofflocations(specifiedDestinationForm.dropofflocations);
    setTotalPaxValues(specifiedDestinationForm.pax);
    setTotalLugageValues(specifiedDestinationForm.lugage);
    setspecifiedDestinationFormData({
      pickuplocation: specifiedDestinationForm.pickuplocation,
      dropofflocations: specifiedDestinationForm.dropofflocations,
      traveldate: specifiedDestinationForm.traveldate,
      pickuptime: specifiedDestinationForm.pickuptime,
      dropofftime: specifiedDestinationForm.dropofftime,
      dropOffDateTime: specifiedDestinationFormData.dropOffDateTime,
      pax: specifiedDestinationForm.pax,
      lugage: specifiedDestinationForm.lugage,
      isAirportTransfer: specifiedDestinationForm.isAirportTransfer,
      isToAirport: specifiedDestinationForm.isToAirport,
      isFromAirport: specifiedDestinationForm.isFromAirport,
      isStationTransfer: specifiedDestinationForm.isStationTransfer,
      isToStation: specifiedDestinationForm.isToStation,
      isFromStation: specifiedDestinationForm.isFromStation,
    });
    if (
      specifiedDestinationForm.traveldate != null ||
      specifiedDestinationForm.traveldate !== ""
    ) {
      setTravelDatePicker(new Date(specifiedDestinationForm.traveldate));
      setFormatedTravelDate(specifiedDestinationForm.traveldate);
    }
  }, []);

  /**
   * * set total pax
   */
  const setTotalPaxValues = (formData) => {
    var summed = getTotalPaxCount(formData);
    setTotalPax(summed);
  };

  const setTotalLugageValues = (formData) => {
    var summed = getTotalLuggageCount(formData);
    setTotalLugage(summed);
  };

  /**
   * * Set state from data variable values when changes are made
   */

  const setPaxFormDataToState = (formData) => {
    var summedPax = getTotalPaxCount(formData);
    setTotalPax(summedPax);
    if (summedPax > 0) {
      handleChangeValidation("pax", true);
    } else {
      handleChangeValidation("pax", false);
    }
    setspecifiedDestinationFormData({
      ...specifiedDestinationFormData,
      pax: formData,
    });
  };

  const setLugageFormDataToState = (formData) => {
    setChangeLuggage(true);
    setformDataValidation({
      ...formDataValidation,
      luggage: true,
    });
    var summedLugage = getTotalLuggageCount(formData);
    setTotalLugage(summedLugage);
    setspecifiedDestinationFormData({
      ...specifiedDestinationFormData,
      lugage: formData,
    });
  };

  /**
   * * Use for pax popup as a reference element
   */
  useOutsideAlerter(wrapperRef);

  /**
   * * PAX selection popup closing function. Click anywhere outside the popup modal to close it.
   */
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setPassangeVisible(false);
          setLugageVisible(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  /**
   * * Search for available vehicles
   */
  const searchAvailableVehicles = () => {
    // Block when an adjacent duplicate remains (e.g. the single dropoff equals
    // the pickup, or the pickup was changed to match the first dropoff).
    if (findDuplicateAdjacentDropoffIndex(pickuplocation, dropofflocations) !== -1) {
      setShowDuplicateLocationModal(true);
      return;
    }
    const status = setFormValidationValues();
    if (search.pathname === "/" || search.pathname === "/en/" || search.pathname === "/jp/") {
      if (!status) {
        const mfdObj = specifiedDestinationFormData;
        mfdObj.pickuplocation = pickuplocation;
        mfdObj.dropofflocations = dropofflocations;
        setSpecificDestination(mfdObj);
      }
    } else {
      if (!status) {
        const mfdObj = specifiedDestinationFormData;
        mfdObj.pickuplocation = pickuplocation;
        mfdObj.dropofflocations = dropofflocations;
        setSpecificDestination(mfdObj);
        checkSpecifiedDestinationFormAvailableVehicle(mfdObj);

        pushEventGTM({
          event: "search",
          search_term: "Search Available Vehicles",
        });
      }
    }
  };

  const debouncedSearchAvailableVehicles = debounce(
    searchAvailableVehicles,
    500
  );

  /**
   * * Form validation
   */
  const setFormValidationValues = () => {
    let status = true;
    if (
      pickuplocation === "" ||
      dropofflocations[0].place_id === undefined ||
      specifiedDestinationFormData.traveldate === "" ||
      specifiedDestinationFormData.pickuptime === "" ||
      getTotalPaxCount(specifiedDestinationFormData.pax) === 0 ||
      changeLuggage === false
    ) {
      status = true;
      setformDataValidation({
        pickuplocation: pickuplocation === "" ? false : true,
        dropofflocations:
          dropofflocations[0].place_id === undefined ? false : true,
        traveldate:
          specifiedDestinationFormData.traveldate === "" ? false : true,
        pickuptime:
          specifiedDestinationFormData.pickuptime === "" ? false : true,
        pax:
          getTotalPaxCount(specifiedDestinationFormData.pax) === 0
            ? false
            : true,
        luggage: changeLuggage === false ? false : true,
      });
    } else {
      status = false;
    }

    return status;
  };

  /**
   * * Set multi-destination state and dispatch it to the redux store
   */
  const setSpecificDestination = (specifiedDestinationFormData) => {
    const specifiedDestinationFormDataObj = {
      pickuplocation: specifiedDestinationFormData.pickuplocation ? specifiedDestinationFormData.pickuplocation : pickuplocation,
      dropofflocations: specifiedDestinationFormData.dropofflocations ? specifiedDestinationFormData.dropofflocations : dropofflocations,
      traveldate: specifiedDestinationFormData.traveldate,
      pickuptime: specifiedDestinationFormData.pickuptime,
      dropofftime: specifiedDestinationFormData.dropofftime,
      dropOffDateTime: specifiedDestinationFormData.dropOffDateTime,
      pax: specifiedDestinationFormData.pax,
      lugage: specifiedDestinationFormData.lugage,
      isAirportTransfer: specifiedDestinationFormData.isAirportTransfer,
      isFromAirport: specifiedDestinationFormData.isFromAirport,
      isToAirport: specifiedDestinationFormData.isToAirport,
      isStationTransfer: specifiedDestinationFormData.isStationTransfer,
      isFromStation: specifiedDestinationFormData.isFromStation,
      isToStation: specifiedDestinationFormData.isToStation,
    };
    dispatch(
      addSpecifiedDestinationFormToState(specifiedDestinationFormDataObj)
    );
    dispatch(addSingleDestinationFormToState(null));
    dispatch(addMultipleDestinationFormToState(null));
    dispatch(addAirportFormToState(null));
    dispatch(addByTheHourFormToState(null));
    const currentLng = i18n.language || "jp";

    // Redirect to the localized version of /book
    // Ensure the leading slash is present to avoid relative path stacking
    history.push(`/${currentLng}/book`);
  };

  const checkIsAirportOrStation = (pickupLocation, dropoffLocations) => {
    const AIRPORT_KEYWORDS = ["airport", "空港"];
    const STATION_KEYWORDS = ["station", "駅"];

    const AIRPORT_NAMES = ["haneda", "羽田", "narita", "成田", "kansai", "関西", "itami", "伊丹", "chubu", "chubu centrair", "中部国際"];
    const STATION_NAMES = ["tokyo", "東京", "shinjuku", "新宿", "shinagawa", "品川"];

    const isMatchingPlace = (location, typeKeywords, nameKeywords) => {
      if (!location || !location.formatted_address || !location.types) return { isMatch: false, type: "none" };

      const typesLower = location.types.map(t => t.toLowerCase());
      const addressParts = location.formatted_address.toLowerCase().split(",");

      if (typesLower.includes("airport") || typesLower.includes("train_station") || typesLower.includes("subway_station")) {

        if (typesLower.includes("airport")) {
          return { isMatch: true, type: "airport" };
        } else {
          // Check for matching type and address parts
          for (let i = 0; i < addressParts.length; i++) {
            for (let keyword of typeKeywords) {
              for (let name of nameKeywords) {
                if (
                  addressParts[i].includes(name) &&
                  addressParts[i].includes(keyword)
                ) {
                  return { isMatch: true, type: "station" };
                }
              }
            }
          }
        }
      }

      // // Fallback: if location.types directly includes one of the types
      // if (typesLower.includes("airport")) return { isMatch: true, type: "airport" };
      // if (typesLower.includes("train_station") || typesLower.includes("subway_station")) return { isMatch: true, type: "station" };

      return { isMatch: false, type: "none" };
    };

    const pickup = isMatchingPlace(pickupLocation, [...AIRPORT_KEYWORDS, ...STATION_KEYWORDS], [...AIRPORT_NAMES, ...STATION_NAMES]);
    const dropoffLoc = dropoffLocations?.[dropoffLocations.length - 1];
    const dropoff = isMatchingPlace(dropoffLoc, [...AIRPORT_KEYWORDS, ...STATION_KEYWORDS], [...AIRPORT_NAMES, ...STATION_NAMES]);

    return {
      check: pickup.isMatch || dropoff.isMatch,
      pickupStatus: pickup.isMatch,
      dropoffStatus: dropoff.isMatch,
      pickupType: pickup.type,
      dropoffType: dropoff.type
    };
  };

  useEffect(() => {
    if (
      !pickuplocation &&
      !dropofflocations[dropofflocations.length - 1].address_components
    )
      return;

    const { check, pickupStatus, dropoffStatus, dropoffType, pickupType } = checkIsAirportOrStation(pickuplocation, dropofflocations);

    if (check) {
      if (dropoffType === "airport" || pickupType === "airport" || dropoffType === "station" || pickupType === "station") {
        setspecifiedDestinationFormData({
          ...specifiedDestinationFormData,
          isAirportTransfer: dropoffType === "airport" || pickupType === "airport",
          isFromAirport: (pickupStatus && pickupType === "airport" ? true : false),
          isToAirport: (dropoffStatus && dropoffType === "airport" ? true : false),
          isStationTransfer: dropoffType === "station" || pickupType === "station",
          isFromStation: (pickupStatus && pickupType === "station" ? true : false),
          isToStation: (dropoffStatus && dropoffType === "station" ? true : false)
        });
      }
    } else {
      setspecifiedDestinationFormData({
        ...specifiedDestinationFormData,
        isAirportTransfer: false,
        isFromAirport: false,
        isToAirport: false,
        isStationTransfer: false,
        isFromStation: false,
        isToStation: false
      });
    }
  }, [pickuplocation, dropofflocations]);

  /**
   * * Set pickup location
   * Note: c.types[0].includes("administrative_area_level_1") => "administrative area level 1 is where the city is returned in the API call"
   */
  const pickupLocationSelected = async (place) => {
    if (place === undefined) return;

    const level1 = place.address_components.find(c => c.types.includes("administrative_area_level_1"));

    const city = level1?.long_name || null;
    place.lat = place.geometry.location.lat;
    place.lon = place.geometry.location.lng;
    place.label = place.formatted_address;
    place.value = place.place_id;
    place.city = city;
    place.prefecture = city;

    setpickuplocation(place);
    availabilityValueReset();
    handleChangeValidation("pickuplocation", true);

    // If the newly selected pickup matches the first dropoff, alert and clear
    // that dropoff so the two adjacent locations can't be the same.
    const firstDropoffId = getPlaceId(dropofflocations?.[0]);
    if (firstDropoffId && firstDropoffId === getPlaceId(place)) {
      setShowDuplicateLocationModal(true);
      setdropofflocations([{}, ...dropofflocations.slice(1)]);
    }
  };

  /**
   * * Set multiple destinations
   */
  const setDestinations = (places) => {
    // A dropoff repeating the location right before it (pickup or the previous
    // dropoff) is not allowed. Alert the user and clear the duplicate entry —
    // remove the extra field when there are several, otherwise reset the single
    // remaining dropoff (which can be a duplicate of the pickup).
    const duplicateIndex = findDuplicateAdjacentDropoffIndex(pickuplocation, places);
    if (duplicateIndex !== -1) {
      setShowDuplicateLocationModal(true);
      setdropofflocations(
        places.length > 1 ? places.filter((_, index) => index !== duplicateIndex) : [{}]
      );
      availabilityValueReset();
      return;
    }
    setdropofflocations(places);
    availabilityValueReset();
  };

  /**
   * * Show and hide pax panel / modal
   */
  const setPaxAndLuggaePannalVisibility = (status) => {
    setPassangeVisible(status);
  };

  const handleChangeDropoffValidation = (condition) => {
    setformDataValidation((formDataValidation) => ({
      ...formDataValidation,
      dropofflocations: condition,
    }));
  };

  const handleChangeValidation = (key, condition) => {
    setformDataValidation((formDataValidation) => ({
      ...formDataValidation,
      [key]: condition,
    }));
  };

  const handleChangeRaw = (date) => {
    //add collon after second number but make logic if user want to delete text
    if (date.length == 2 && date.includes(":") == false) {
      date = date + ":";
    } else if (date.length == 3 && date.includes(":") == true) {
      date = date.substring(0, date.length - 1);
    }
    if (
      date.length == 5 &&
      date.includes(":") &&
      date.split(":")[0] <= 24 &&
      date.split(":")[1] <= 60
    ) {
      if (date.split(":")[0] == 24 && date.split(":")[1] > 0) {
        handleChangeValidation("pickuptime", false);
      } else {
        handleChangeValidation("pickuptime", true);
      }
    } else {
      handleChangeValidation("pickuptime", false);
    }
    setspecifiedDestinationFormData({
      ...specifiedDestinationFormData,
      pickuptime: date.isempty ? "" : date,
    });
  };

  return (
    <div className="bg-white p-3 p-md-3 card-form-custom">
      {/* Duplicate adjacent location alert */}
      <MotionModal
        show={showDuplicateLocationModal}
        onClose={() => setShowDuplicateLocationModal(false)}
        maxWidthClassName="tw:max-w-[420px]"
        panelClassName="tw:border-t-4 tw:border-[#ED553B] tw:p-6 tw:text-center"
      >
        <ModalCloseButton onClick={() => setShowDuplicateLocationModal(false)} className="tw:right-2 tw:top-2" />
        <div style={{ color: "#ED553B", fontSize: "16px", fontWeight: 500 }}>
          {t("SpecifiedDestination.SameLocation.Validation")}
        </div>
      </MotionModal>

      {/* FIRST LINE INPUT */}
      <div className="tw:grid tw:gap-3 tw:mb-5 tw:md:mb-8">
        {/* PICKUP ADDRESS */}
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 input-box ">
          <div className="form-floating position-relative">
            <CustomGoogleAutoComplete
              id="pickup1"
              placeholder="Pick-up: Airport, Hotel, Attraction, etc. "
              onPlaceSelected={pickupLocationSelected}
              defaultValue={
                specifiedDestinationFormData.pickuplocation?.formatted_address
              }
              invalidText={"SpecifiedDestination.Pickup.Specific.Validation"}
              isInvalid={!formDataValidation.pickuplocation}
            />
            <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
              <div className="d-flex justify-content-center">
                <LocationPinIcon />
              </div>
            </span>
            <label htmlFor="pickUpAddress" className="label-icon">
              {t("Pick.Up.Address")}
            </label>
          </div>
        </div>
        {/* DESTINATION DROP DESKTOP */}
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 ">
          <MultipleDropOff
            isUseAddDestination={true}
            setPaxPanel={setPaxAndLuggaePannalVisibility}
            setDestinations={setDestinations}
            dropofflocations={dropofflocations}
            isNotValidFirstLocation={
              formDataValidation.dropofflocations ? false : true
            }
            changeValidation={handleChangeDropoffValidation}
          />
        </div>

        {/* TRAVEL DATE */}
        <div className="tw:grid tw:grid-cols-2 tw:gap-3">
          <div className="tw:w-full">
            <AnimatedDatePicker
              locale={lang === "EN" || lang === "en" ? "en" : "ja"}
              selected={travelDatePicker}
              minDate={new Date()}
              onSelect={(date) => {
                setTravelDatePicker(date);
                var formatedDate = date.toLocaleDateString("sv-SE", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                });
                var momentDate = date.toLocaleDateString("sv-SE", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                });
                setFormatedTravelDate(momentDate);
                availabilityValueReset();
                handleChangeValidation("traveldate", true);
                setspecifiedDestinationFormData({
                  ...specifiedDestinationFormData,
                  traveldate: formatedDate,
                });
              }}
              customInput={
                <div className="form-floating position-relative">
                  <input
                    readOnly={true}
                    autoComplete={BROWSER_AUTOFILL_OFF}
                    type="text"
                    name="traveldate"
                    className={`tw:!h-[50px] ${formDataValidation.traveldate
                      ? "form-control form-control-icon"
                      : "form-control form-control-icon invalid"
                      }`}
                    style={{
                      borderColor: !formDataValidation.traveldate ? "red" : "",
                      color: specifiedDestinationFormData.traveldate
                        ? "#282828"
                        : "",
                      fontWeight: specifiedDestinationFormData.traveldate
                        ? "bold"
                        : "",
                    }}
                    placeholder="Travel date"
                    aria-label="Travel date"
                    defaultValue={
                      formatedTravelDate && typeof formatedTravelDate === 'string'
                        ? moment(formatedTravelDate, 'YYYY-MM-DD').format(dateFormat[lang])
                        : "" // Use an empty string if the date value is not set
                    }
                  />

                  <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
                    <div className="d-flex justify-content-center">
                      <CalendarIcon color="#DBBE78" size={18} />
                    </div>
                  </span>
                  <label htmlFor="travelDate" className="label-icon">
                    {t("Travel.Date")}
                  </label>
                </div>
              }
            />

            <FieldError show={!formDataValidation.traveldate}>
              {t("SpecifiedDestination.TravelDate.Validation")}
            </FieldError>
          </div>

          {/* PICKUP TIME */}
          <div className="tw:w-full">
            <AnimatedDatePicker
              locale={lang === "EN" || lang === "en" ? "en" : "ja"}
              showTimeSelect
              showTimeSelectOnly
              selectedTime={specifiedDestinationFormData.pickuptime}
              timeIntervals={5}
              timeCaption={t("Pick.Up.Time")}
              timeFormat="HH:mm"
              dateFormat="HH:mm"
              onChange={(date, event) => {
                if (event == undefined) {
                  var formatedDate = date.toLocaleDateString("sv-SE", {
                    hour: "2-digit",
                    minute: "2-digit",
                  });

                  var tge = moment(formatedDate);
                  setspecifiedDestinationFormData({
                    ...specifiedDestinationFormData,
                    pickuptime: tge.format("HH:mm"),
                  });
                  handleChangeValidation("pickuptime", true);
                  availabilityValueReset();
                }
              }}
              onChangeRaw={(event) => handleChangeRaw(event.target.value)}
              customInput={
                <div className="form-floating position-relative">
                  <input
                    type="text"
                    name="pickuptime"
                    maxLength={5}
                    autoComplete={BROWSER_AUTOFILL_OFF}
                    style={{
                      borderColor: !formDataValidation.pickuptime ? "red" : "",
                      color: specifiedDestinationFormData.pickuptime
                        ? "#282828"
                        : "",
                      fontWeight: specifiedDestinationFormData.pickuptime
                        ? "bold"
                        : "",
                    }}
                    onChange={(e) => {
                      // onChange(e);
                      availabilityValueReset();
                    }}
                    className={`tw:!h-[50px] ${formDataValidation.traveldate
                      ? "form-control form-control-icon"
                      : "form-control form-control-icon invalid"
                      }`}
                    placeholder="Pick-up time"
                    aria-label="Pick-up time"
                    value={specifiedDestinationFormData.pickuptime}
                  />
                  <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
                    <div className="d-flex justify-content-center">
                      <ClockIcon />
                    </div>
                  </span>
                  <label htmlFor="pickUpTime" className="label-icon">
                    {t("Pick.Up.Time")}
                  </label>
                </div>
              }
            />

            <FieldError show={!formDataValidation.pickuptime}>
              {t("AirportTransfer.PickupTime.Required")}
            </FieldError>
          </div>
        </div>

        {/* PAX AND LUGAGE */}
        <div ref={wrapperRef} className="tw:grid tw:grid-cols-2 tw:gap-3">
          {/* PASSENGER FORM */}
          <div className="tw:w-full">
            <div className="form-floating position-relative">
              <input
                readOnly={true}
                onClick={() => {
                  setPassangeVisible(!passengerVisible);
                  setLugageVisible(false);
                }}
                style={{
                  color: totalPax > 0 ? "#282828" : "",
                  fontWeight: totalPax > 0 ? "bold" : "",
                }}
                name="pax"
                autoComplete={BROWSER_AUTOFILL_OFF}
                type="number"
                id="passengers"
                className={`tw:!h-[50px] ${formDataValidation.pax
                  ? "form-control form-control-icon"
                  : "form-control form-control-icon invalid"
                  }`}
                placeholder="Passengers"
                aria-label="Passengers"
                min={0}
                value={totalPax ?? 0}
              />
              <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
                <div className="d-flex justify-content-center">
                  <PaxIcon />
                </div>
              </span>
              <label htmlFor="floatingInput" className="label-icon">
                {t("Passengers")}
              </label>
            </div>

            <FieldError show={!formDataValidation.pax}>
              {t("SpecifiedDestination.Passenger.Validation")}
            </FieldError>
          </div>
          {/* LUGGAGE FORM */}
          <div className="tw:w-full">
            <div className="form-floating position-relative">
              <input
                readOnly={false}
                onClick={() => {
                  setLugageVisible(!lugageVisible);
                  setPassangeVisible(false);
                }}
                name="lugage"
                autoComplete={BROWSER_AUTOFILL_OFF}
                style={{
                  color: totalLugage > 0 ? "#282828" : "",
                  fontWeight: totalLugage > 0 ? "bold" : "",
                }}
                type={
                  (formDataValidation.luggage == null &&
                    changeLuggage === false) ||
                    (formDataValidation.luggage === false &&
                      changeLuggage === false)
                    ? "text"
                    : "number"
                }
                id="passengers"
                className={`tw:!h-[50px] ${formDataValidation.luggage ||
                  formDataValidation.luggage == null ||
                  changeLuggage === true
                  ? "form-control form-control-icon"
                  : "form-control form-control-icon invalid"
                  }`}
                placeholder="Lugages"
                aria-label="Lugages"
                min={0}
                value={
                  (formDataValidation.luggage == null &&
                    changeLuggage === false) ||
                    (formDataValidation.luggage === false &&
                      changeLuggage === false)
                    ? "-"
                    : totalLugage ?? 0
                }
              />

              <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
                <div className="d-flex justify-content-center">
                  <LuggageIcon />
                </div>
              </span>
              <AnimatePresence>
                {lugageVisible === true && (
                  <PassengerCard
                    setPaxPanel={setPaxAndLuggaePannalVisibility}
                    setFormDataToState={setLugageFormDataToState}
                    passengerFormData={specifiedDestinationFormData.lugage}
                    passangerForm={false}
                    luggageForm={true}
                  />
                )}
              </AnimatePresence>
              <AnimatePresence>
                {passengerVisible === true && (
                  <PassengerCard
                    setPaxPanel={setPaxAndLuggaePannalVisibility}
                    setFormDataToState={setPaxFormDataToState}
                    passengerFormData={specifiedDestinationFormData.pax}
                    passangerForm={true}
                    luggageForm={false}
                  />
                )}
              </AnimatePresence>

              <label className="label-icon">{t("Luggage")}</label>
            </div>
          </div>
        </div>
      </div>

      {/* LAST LINE (BUTTON)*/}
      <div className="d-grid ">
        <motion.button
          type="button"
          disabled={isLoading}
          {...searchButtonMotionProps(isLoading, shouldReduceMotion)}
          className="btn btn-primary btn-sm rounded-3  d-flex justify-content-center px-md-5 tw:h-[50px]"
          onClick={debouncedSearchAvailableVehicles}
        >
          <div className="d-flex align-items-center px-2 d-inline text-white tw:text-base tw:font-hanken-grotesk tw:font-medium tw:w-full tw:justify-center">
            <ButtonLoadingSwap
              isLoading={isLoading}
              spinner={
                <div className="spinner-border tw:text-white" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              }
            >
              <>
                {t("Search.Available.Vehicles")}
                <i className="ps-2">
                  <ArrowRightIcon color="#FFFFFF" size={24} />
                </i>
              </>
            </ButtonLoadingSwap>
          </div>
        </motion.button>
      </div>
    </div>
  );
};

export default SpecifiedDestinationForm;